import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import {
  getPerson,
  edit as editPerson,
} from '../../Actions/Person.action';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import Person from '../../Types/Person';
import Input from '../Inputs/Input';
import RadioButton from '../Inputs/Radiobutton';

const MyPagesEditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [person, setPerson] = useState<Person>();

  const fetchUser = async () => {
    const person = await getPerson(id);
    setPerson(person);
    setIsLoading(!isLoading);
  };

  const setPersonValue = (key, value) => {
    const personCopy = Object.assign({}, person);
    personCopy[key] = value;
    setPerson(personCopy);
  };

  const submitForm = () => {
    dispatch(editPerson(person));
    navigate(-1);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="col-span-2">
      <h1 className="mb-2">{translate('mypage.person.edituser')}</h1>
      <p className="mb-4 max-w-3xl text-lg lg:mb-6">
        {translate('mypage.editusers.text') !== 'mypage.editusers.text' &&
          translate('mypage.editusers.text')}
      </p>
      <form className="flex flex-col">
        <Input
          inputSize="large"
          label={translate('mypage.person.firstname')}
          wrapperClassName="mb-4 [&_.input]:text-lg"
          value={person?.firstName}
          onChange={(e) => setPersonValue('firstName', e.target.value)}
          placeholder={translate('general.placeholder.firstname')}
          type="text"
          id="fname"
          disabled={isLoading}
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.lastname')}
          wrapperClassName="mb-4 [&_.input]:text-lg"
          onChange={(e) => setPersonValue('lastName', e.target.value)}
          value={person?.lastName}
          placeholder={translate('general.placeholder.lastname')}
          type="text"
          id="lname"
          disabled={isLoading}
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.email')}
          wrapperClassName="mb-4 [&_.input]:text-lg"
          onChange={(e) => setPersonValue('email', e.target.value)}
          value={person?.email}
          placeholder={translate('general.placeholder.email')}
          type="email"
          id="email"
          disabled={isLoading}
        />
        <Input
          inputSize="large"
          label={translate('mypage.person.phone')}
          wrapperClassName="mb-4 [&_.input]:text-lg"
          onChange={(e) => setPersonValue('phone', e.target.value)}
          placeholder={translate('general.placeholder.phone')}
          type="tel"
          value={person?.phone}
          id="tel"
          disabled={isLoading}
        />
        <div className="flex flex-col gap-4 pb-6 pt-2 lg:pb-8 lg:pt-4">
          <RadioButton
            name="role-radio"
            inputSize="large"
            label={translate('general.order.placer')}
            value="OrderPlacer"
            id="role1"
            checked={person?.role === 'OrderPlacer'}
            onChange={(e) => setPersonValue('role', e.target.value)}
            wrapperClassName="text-lg flex gap-2"
            disabled={isLoading}
          />
          <RadioButton
            name="role-radio"
            inputSize="large"
            label={translate('general.order.approver')}
            value="OrderApprover"
            id="role2"
            checked={person?.role === 'OrderApprover'}
            onChange={(e) => setPersonValue('role', e.target.value)}
            wrapperClassName="text-lg flex gap-2"
            disabled={isLoading}
          />
        </div>
      </form>
      <div className="flex gap-2">
        <button
          className="btn btn--primary btn--large"
          onClick={() => submitForm()}
          disabled={isLoading}
        >
          {translate('general.save')}
        </button>
        <button
          className="btn btn--clear btn--large"
          onClick={() => navigate(-1)}
        >
          {translate('general.cancel')}
        </button>
      </div>
    </div>
  );
};

export default MyPagesEditUser;
